import list from './list';
import manage from './manage';

export default [...list, ...manage];
